export default {
  meta: {
    title: '市场调研',
  }
};
